import { styled } from 'style/ORSNNTheme';

const Col = styled.div`
  display: inline-block;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  white-space: nowrap;

  // &:nth-child(even) {
  //   background-color: ${(props) => props.theme.color.gray100}};
  // }
`;

export { Col, Row };
